import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import {
  Card,
  CardContent,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useSelector } from "react-redux";
import configServ from "../../services/config";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Activities = ({ customerId }) => {
  const [loading, setLoading] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [startIndex, setStartIndex] = useState(0);
  const chunkSize = 7; // Number of days per page
  const { customer_id } = useSelector((state) => state.GlobalVariables);

  useEffect(() => {
    const fetchVideoPercentages = async () => {
      setLoading(true);
      try {
        const response = await configServ.getUserProgress({ user_id: customer_id });
        if (response.success) {
          const sortedData = response.progress.sort(
            (a, b) => new Date(b.date) - new Date(a.date) // Latest first
          );
          setDataList(sortedData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVideoPercentages();
  }, [customer_id]);

  const displayedData = dataList.slice(startIndex, startIndex + chunkSize);

  const barChartData = {
    labels: displayedData.map((data) =>
      new Date(data.date).toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
      })
    ),
    datasets: [
      {
        label: "Completion Percentage",
        data: displayedData.map((data) => data.progress_percentage),
        backgroundColor: "#f0b120",
      },
    ],
  };

  const barChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: { ticks: { autoSkip: false } },
    },
  };

  return (
    <Card sx={{ mt: 4, p: 3, borderRadius: 2, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Previous Days Progress
        </Typography>

        {loading ? (
          <CircularProgress sx={{ display: "block", mx: "auto", my: 2 }} />
        ) : dataList.length === 0 ? (
          <Typography variant="body1" color="textSecondary" align="center">
            No progress data available.
          </Typography>
        ) : (
          <div style={{ height: "300px" }}>
            <Bar data={barChartData} options={barChartOptions} />
          </div>
        )}

        {/* Pagination Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "16px",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => setStartIndex(startIndex - chunkSize)}
            disabled={startIndex === 0}
          >
            Previous
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setStartIndex(startIndex + chunkSize)}
            disabled={startIndex + chunkSize >= dataList.length}
          >
            Next
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default Activities;
